import { useState, useEffect, useMemo, useCallback } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from "@progress/kendo-react-layout";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import { useTranslation } from "react-i18next";
import EventService from "../../../services/srv-event/EventService";
import { eventGridColumns } from "./EventGridColumns";
import CommonGrid from "../../../components/sys-common/CommonGrid";
import ButtonGroup from "../../../components/ButtonGroup/ButtonGroup";
import SectionService from "../../../services/srv-section/SectionService";

const EventList = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [sectionList, setSectionList] = useState([]);
  const [selectedSection, setSelectedSection] = useState("all");

  const initialDataState = {
    take: 10,
    skip: 0,
    sort: [{ field: "etkinliK_TANIM_ID", dir: "desc" }],
    filter: { logic: "and", filters: [] },
  };

  const [dataState, setDataState] = useState(initialDataState);
  const [data, setData] = useState(null);

  useEffect(() => {
    SectionService.getList().then((data) => {
      setSectionList(data);
      // getData();
    });
  }, []);

  useEffect(() => {
    getData();
  }, [dataState]);

  useEffect(() => {
    if (props.isAdded) {
      getData();
      props.setIsAdded(false);
    }
  }, [props.isAdded]);

  const getData = () => {
    setLoading(true);
    EventService.getList(dataState).then((data) => {
      setData(data?.data);
      setLoading(false);
    });
  };

  const handleSectionChange = useCallback((value) => {
    setSelectedSection(value);
    if (value === "all") {
      setDataState(initialDataState);
    } else {
      setDataState((prevState) => ({
        ...prevState,
        filter: {
          logic: "and",
          filters: [
            { field: "boluM_KODU", operator: "eq", value: value.toLowerCase() },
          ],
        },
      }));
    }
  }, []);

  const handleEdit = (dataItem) => {
    props.setSelectedEvent(dataItem);
    props.toggleDialogUpdateEvent();
  };

  const buttonGroupOptions = useMemo(() => {
    return sectionList.map((section) => ({
      text: section.boluM_ADI,
      value: section.boluM_KODU,
    }));
  }, [sectionList]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("events")}</CardTitle>
      </CardHeader>
      <CardBody>
        {loading ? <LoadingPanel /> : null}
        <ButtonGroup
          buttons={buttonGroupOptions}
          activeButton={selectedSection}
          onButtonClick={handleSectionChange}
        />
        <CommonGrid
          style={{ marginTop: "20px" }}
          data={data}
          dataState={dataState}
          onDataStateChange={(event) => setDataState(event.dataState)}
          columns={eventGridColumns}
          addButton={{
            text: t("add_events"),
            onClick: props.toggleDialogAddEvent,
          }}
          editButton={{
            text: t("edit"),
            onClick: handleEdit,
          }}
          detailButton={{
            text: t("detail"),
            onClick: props.goEventDetail,
          }}
          exportExcelProps={{
            loadingFunction: setLoading,
            serviceMethod: EventService.getEventsForExcel,
            fileName: "EtkinlikListesi",
          }}
          dataItemKey="etkinliK_TANIM_ID"
        />
      </CardBody>
    </Card>
  );
};

export default EventList;
